import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, func, node, number, oneOfType, shape, string,
} from 'prop-types'

// isWrappable lets the options wrap onto another row on narrow screens instead of
// shrinking below a readable width.
function OptionGroup({ id, label, options, value, onChange, isWrappable = false }) {
  const labelId = `${id}-label`

  return (
    <div className="generation-settings__row">
      <span id={labelId} className="generation-settings__row-label cgt-body-base-semibold">{label}</span>
      <div
        className={classnames(
          'generation-settings__options',
          isWrappable && 'generation-settings__options--wrap',
        )}
        role="group"
        aria-labelledby={labelId}
      >
        {options.map((option) => {
          const isSelected = option.value === value
          return (
            <button
              key={option.value}
              type="button"
              className={classnames(
                'generation-settings__option cgt-caption-semibold',
                isSelected && 'generation-settings__option--selected',
              )}
              aria-pressed={isSelected}
              onClick={() => onChange(option.value)}
            >
              {option.icon}
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

const valueType = oneOfType([string, number])

OptionGroup.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  options: arrayOf(shape({
    value: valueType.isRequired,
    label: string.isRequired,
    icon: node,
  })).isRequired,
  value: valueType.isRequired,
  onChange: func.isRequired,
  isWrappable: bool,
}

export default memo(OptionGroup)
